<script setup lang="ts">
import { formatCurrency } from '@helpers/numberHelper'

interface MarketValueProps {
  value: number
  priceChange: number
  currency: string
}

defineProps({
  value: null,
  priceChange: null,
  currency: null
})

function getTrendIcon(change: number) {
  if (change > 0)
    return 'fa-light fa-arrow-trend-up'
  if (change < 0)
    return 'fa-light fa-arrow-trend-down'
  return 'fa-light fa-grip-lines'
}

function getTrendColor(change: number) {
  if (change > 0)
    return 'text-green-500'
  if (change < 0)
    return 'text-red-500'
  return 'text-gray-700'
}

function formatChange(change: number) {
  const prefix = change > 0 ? '+' : ''
  return `${prefix}${change.toFixed(2)}%`
}
</script>

<template>
  <div class="" :class="[getTrendColor(priceChange)]">
    <!-- Large value display -->
    <div class="text-xl font-bold">
      {{ formatCurrency(value, currency) }}
    </div>

    <!-- Trend line and change -->
    <div class="flex justify-start gap-2">
      <i
        class="text-md relative top-1"
        :class="[getTrendIcon(priceChange)]"
      />
      <span class="text-md font-medium">
        {{ formatChange(priceChange) }}
      </span>
    </div>
  </div>
</template>
